import { render, staticRenderFns } from "./PacketsExpeditionProcess.vue?vue&type=template&id=515b6e8a&scoped=true"
import script from "./PacketsExpeditionProcess.vue?vue&type=script&lang=js"
export * from "./PacketsExpeditionProcess.vue?vue&type=script&lang=js"
import style0 from "./PacketsExpeditionProcess.vue?vue&type=style&index=0&id=515b6e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515b6e8a",
  null
  
)

export default component.exports